import { surfaces } from '@ui/kit';
import { makeScalarToken, makeSelectors } from '@utils/css';

const hotspotSurface = surfaces.accent.default.__extend("--hotspot-color");
const imageScale = makeScalarToken("--hotspot-scale", "1");
const aspectRatio = "_mwa1fajvqv";
const imageContainer = "_mwi1aapci1";
const image = "_mwitvywxe";
const hotspotList = "_mwhd8qa1i";
const hotspotModifiers = makeSelectors({
  withoutPulse: "_mww1c0p3sf",
  withIndex: "_mww1ax8bq3",
  withGraphic: "_mwwb29a7s",
  active: "_mwa1e90t35"
});
const hotspot = "_mwht7qtpz";
const trigger = "_mwt9huzx2";
const hotspotGraphic = "_mwh11785xz";
const hotspotBullet = "_mwha3ixdk";

export { aspectRatio, hotspot, hotspotBullet, hotspotGraphic, hotspotList, hotspotModifiers, hotspotSurface, image, imageContainer, imageScale, trigger };
import "./_content.style.linaria.module.css";
//# sourceMappingURL=_content.style.js.map
